import { getBasePageUrlFromRole } from "@/assets/js/helpers";
import { useSessionStore } from "@/store/session";
import { createRouter, createWebHistory } from "vue-router";
import { routes, handleHotUpdate } from "vue-router/auto-routes";

const router = createRouter({
	history: createWebHistory(),
	scrollBehavior(to, from, savedPosition) {
		if (to.meta.returnToTop) {
			return { top: 0 };
		}
		return savedPosition || { top: 0 };
	},
	routes,
});

if (import.meta.hot) {
	handleHotUpdate(router);
}

router.beforeEach(async (to, from) => {
	// Forbid going to auth pages if user is logged in
	const authPage = "auth";
	if (to.matched.some((match) => match.name === authPage)) {
		const sessionStore = useSessionStore();
		const isLoggedIn = sessionStore.isLoggedIn;
		if (isLoggedIn && to.name !== "auth.validation") {
			if (!from || !from.name) {
				return { name: getBasePageUrlFromRole(sessionStore.roleId) } as any;
			}
			return false;
		}
		return true;
	} else {
		const sessionStore = useSessionStore();
		const rolePage = to.matched.find((el) => el.meta.roleIds);
		const isLoggedIn = sessionStore.isLoggedIn;
		if (!isLoggedIn && from.name) {
			return { name: "auth.login" };
		}
		if (rolePage) {
			const reuiredRoles = rolePage.meta.roleIds as number[];
			if (
				reuiredRoles &&
				!reuiredRoles.includes(sessionStore.roleId) &&
				from.name
			) {
				return { name: getBasePageUrlFromRole(sessionStore.roleId) };
			}
		}
		return true;
	}
});

export default router;
